import React from 'react';
import { Stack, Text } from '@fluentui/react';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { ICustomerImpactResponseDto } from 'generated/cxp-backend';
import './AddCustomerWizard.scss';

export function validateCustomerFamilyResult(result: ICustomerImpactResponseDto | undefined): ICustomerImpactResponseDto {
    if (!result?.originalRequestId || !result.outcomes?.length || result.outcomes.some(outcome =>
        !outcome.requestId || !outcome.attachmentTarget ||
        !['Created', 'Updated'].includes(outcome.action || '') ||
        (outcome.action === 'Created' && !outcome.requestedResolutionDate) ||
        (outcome.requestedResolutionDate && Number.isNaN(outcome.requestedResolutionDate.getTime()))
    )) {
        throw new Error('The service did not return customer ticket outcomes. Check Manage Requests before retrying.');
    }
    return result;
}

const CustomerFamilyResult: React.FC<{ result: ICustomerImpactResponseDto }> = ({ result }) => (
    <Stack tokens={{ childrenGap: 16 }}>
        <ul className="customer-family-results" aria-label="Customer ticket outcomes">
            {result.outcomes?.map((outcome, index) => (
                <li
                    key={`${outcome.requestId}-${index}`}
                    className="customer-family-result"
                    data-testid="customer-family-result-row"
                >
                    <Stack tokens={{ childrenGap: 8 }}>
                        <Text variant="mediumPlus" as="h2">{outcome.customerName || <Trans>General feedback</Trans>}</Text>
                        <Text><Trans>{outcome.action}</Trans> · <strong>{outcome.requestId}</strong></Text>
                        <Text>
                            <Trans>Requested resolution date</Trans>: {outcome.requestedResolutionDate
                                ? outcome.requestedResolutionDate.toLocaleDateString(undefined, { timeZone: 'UTC' })
                                : <Trans>Not set</Trans>}
                        </Text>
                        <Link
                            to={`/request/${outcome.requestId}`}
                            data-testid="customer-family-result-request-link"
                        >
                            <Trans>View request</Trans> {outcome.requestId}
                        </Link>
                    </Stack>
                </li>
            ))}
        </ul>
        {result.parentRequestId && (
            <Link
                to={`/request/${result.parentRequestId}`}
                data-testid="customer-family-result-parent-link"
            >
                <Trans>View parent request</Trans> {result.parentRequestId}
            </Link>
        )}
        <Link to="/manage-requests" data-testid="customer-family-result-manage-link">
            <Trans>Manage Requests</Trans>
        </Link>
    </Stack>
);

export default CustomerFamilyResult;
